module.exports = __webpack_public_path__ + "img/jddetails-mob.da569bf9.svg";